import { IEnvironmentSpecificConfig, IAuthConfig } from './common';
import { Platform } from './platform';

// detects if we are in edn network or not
export const isEDN = function isInEDN() {
    // EDN Domain names in.telstra.com.au
    const EDN_IN_DOMAIN_ENDS_WITH = `in.telstra.com.au`;
    const EDN_CORP_DOMAIN_ENDS_WITH = `corp.telstra.com`;

    // Web and sso
    if (Platform.isDesktop && window.location.hostname) {
        // https in localhost is local EDN domain for development
        return window.location.hostname === 'localhost'
            && window.location.protocol === 'https:' ? true : window.location.hostname.endsWith(EDN_IN_DOMAIN_ENDS_WITH) ||
                window.location.hostname.endsWith(EDN_CORP_DOMAIN_ENDS_WITH);
    }
    return false;
}();

// detects if we are in edn network or not
export const isCorpDomain = function isInCorpDomain() {
    // EDN Domain names in.telstra.com.au
    const EDN_CORP_DOMAIN_ENDS_WITH = `corp.telstra.com`;
    // Web and sso
    if (Platform.isDesktop && window.location.hostname) {
        return window.location.hostname.endsWith(EDN_CORP_DOMAIN_ENDS_WITH);
    }
    return false;
}();

const getAuthUrl = (baseConfig: IEnvironmentSpecificConfig) => {
    const isForProduction = !baseConfig.isForDevelopment;

    if (isEDN) {
        // if EDN network redirect to ACCOUNT-01
        return isForProduction
            ? `https://private-tapi.t-dev.in.telstra.com.au/v1/sso`
            : `https://qa.org005.t-dev.in.telstra.com.au/v1/sso`;
    } else {
        // CIP Identiy
        return baseConfig.cipUrl
    }
};

const getRedirectUrl = (baseConfig: IEnvironmentSpecificConfig) => {
    // Web
    if (Platform.isDesktop && window.location) {
        return window.location.protocol + '//' + window.location.host;
    }

    // Mobile
    return baseConfig.appHostUrl;
};

export const getAuthConfig = (
    baseConfig: IEnvironmentSpecificConfig
): IAuthConfig => {
    const commonConfig = {
        url: getAuthUrl(baseConfig),
        defaultRedirectUrl: getRedirectUrl(baseConfig),
        params: {
            responseType: ['id_token', 'token'],
            responseMode: 'fragment',
            scopes: ['openid', 'b2b', 'username', 'profile', 'email']
        }
    };
    if (isEDN) {
        return {
            ...commonConfig,
            clientId: baseConfig.isForDevelopment ? '9IgttAP5jGF8TVFjnQ8DJcAFmbRIOmuW'
                : 'tN1j6ZG6C8osSQWhFLeiSPpOBADsr4JQ',
            params: {
                ...commonConfig.params,
                scopes: [
                    'openid',
                    'profile',
                    'email',
                    'telstra.user.sso.profile',
                    'phone'
                ]
            }
        };
    }
    return { ...commonConfig, clientId: 'b2b-telstraconnect' };
};
